import React, { useState, useEffect } from "react";
import { Badge, Tooltip, Radio } from "antd";

const { Group, Button } = Radio;

const segmentedOptionsStatic = [
	{
		label: <span>Original</span>,
		value: "Original",
	},
	{
		label:
			<Tooltip
				title="'Edited' provides unedited original transactions and any edited transactions, such as split transactions.">
				<span>Edited</span>
			</Tooltip>,
		value: "Edited",
	},
]

const OriginalEditedToggle = (props) => {

	const [segmentedOptions, setSegmentedOptions] = useState(segmentedOptionsStatic)

	useEffect(() => {
		if (props.needsReviewCount && props.needsReviewCount > 0) {
			setSegmentedOptions(prevState => [...prevState, {
					label:
						<Badge
							count={props.needsReviewCount}
							offset={[-1, 1]}
							showZero={false}
						>
							<span>Needs Review</span>
						</Badge>,
					value: "Needs Review"
				}
			]);
		}
	}, [props.needsReviewCount])

	return (
		<Group 
			defaultValue={props.transactionsKind} 
			onChange={(e) => props.handleTransactionsKindChange(e.target.value)}
		>
			{segmentedOptionsStatic.map((option) => (
				<Button 
					value={option.value}
					style={props.transactionsKind === option.value ? {} : {color: "#cccccc"}}
					key={option.value}
				>
					{option.label}
				</Button>
			))}
		</Group>
	);
};

export default OriginalEditedToggle;